"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  SEARCH: 'Search',
  CAR_DETAILS: 'Car details',
  FILTERS: 'Filters',
  RENTAL_POLICIES: 'Rental policies',
  DISCOUNTS: 'Discounts',
  PASSWORD: 'Password',
  OTP: 'OTP',
  DRIVER_SUMMARY: 'Driver summary',
  DOCUMENTS: 'Documents',
  BOOKING_CONFIRM: 'Booking Confirmation',
  OFFER: 'Offer',
  UMRAH: 'Umrah Page',
  WORK_EMAIL_VALIDATION: 'work_email_validation',
  WORK_EMAIL_VERIFICATION: 'work_email_verification',
  WORK_EMAIL_VERIFICATION_SUCCESS: 'work_email_verification_success',
  DIRECT_SALE: 'Direct Sale Page'
};